import { useLayoutEffect } from 'react';

import { FontConfig } from '../config/fonts';

export const createStyleText = (config: Record<string, { name: string; weights: (string | number)[] }>) => {
	return Object.values(config)
		.map((font) => {
			const url = new URL('https://fonts.googleapis.com/css2'),
				name = font.name.replace(' ', '+'),
				weights = font.weights.join(';'),
				family = `${name}:wght@${weights}`;

			url.searchParams.append('family', family);
			url.searchParams.append('display', 'swap');

			return `@import url("${decodeURIComponent(url.toString())}");`;
		})
		.join('\n');
};

export const useThemeFonts = () => {
	useLayoutEffect(() => {
		const tag = document.createElement('style');

		tag.innerText = createStyleText(FontConfig);

		document.head.appendChild(tag);

		return () => {
			document.head.removeChild(tag);
		};
	}, []);
};
